import { Page } from "@/components/common/Page";
import { useCallback, useState } from "react";
import JobDetail from "./JobDetail";
import JobList from "./JobList";
import { ScheduledJob } from "@/types/common.types";
import { useNavigate } from "react-router-dom";
import useAnalyticsManager from "@/hooks/miscellaneous/useAnalyticsManager";

const Jobs = () => {
  const navigate = useNavigate();
  const [selectedJob, setSelectedJob] = useState<ScheduledJob | null>(null);
  const { sendEvent } = useAnalyticsManager();
  const onSelectJob = useCallback((job: ScheduledJob) => {
    setSelectedJob(job);
    sendEvent("job_row_clicked", {
      job_id: job.id,
      job_name: job.jobName,
    });
  }, []);
  const onClearSelectedJob = useCallback(() => {
    setSelectedJob(null);
  }, []);
  const onCreateJob = useCallback(() => {
    sendEvent("create_job_button_clicked");
    navigate("/upload");
  }, [navigate]);
  return (
    <Page className="overflow-x-scroll">
      {selectedJob ? (
        <JobDetail job={selectedJob} onBack={onClearSelectedJob} />
      ) : (
        <JobList onSelectJob={onSelectJob} onCreateJob={onCreateJob} />
      )}
    </Page>
  );
};

export default Jobs;
